module.exports = __webpack_public_path__ + "img/weight-gain.4d948daa.svg";